import * as React from 'react';
import {ImageSourcePropType, ImageStyle, StyleSheet, TouchableOpacity, View} from 'react-native';
import {Text} from '../text';
import {IStateProps} from './model';
import useStyles from './styles';
import {Image} from '../image';

export default (props: IStateProps) => {
  const styles = useStyles();
  const imageStyles = StyleSheet.flatten(styles.image);
  const {width, height} = props.imageProps;
  const imageSize = {
    width: width ? width : (imageStyles.width as number),
    height: height ? height : (imageStyles.height as number),
  };

  const imageLinkBuilder = (uri: ImageSourcePropType) => {
    // Источник https://stackoverflow.com/questions/52357246/react-native-disable-image-cache-on-android
    // Только для внешних ресурсов
    if (uri.toString().includes('http')) return `${uri}?${new Date()}` as ImageSourcePropType;
    return uri;
  };

  return (
    <View style={[styles.card, props.style]}>
      {props.imageProps.source ? (
        <View style={styles.imageWrapper}>
          <Image
            resizeMode='contain'
            style={[styles.image as ImageStyle, {width: imageSize.width}, {height: imageSize.height}]}
            source={imageLinkBuilder(props.imageProps.source)}
            {...imageSize}
          />
        </View>
      ) : null}
      <View style={styles.contentWrapper}>
        {props.contacts
          .filter((x) => !!x?.value)
          .map((item, i) => (
            <TouchableOpacity
              testID={`contact-item-${item.value}-${i}-id`}
              onPress={item.onPress}
              key={item.value}
              {...{dataSet: {class: 'link'}}}>
              <View style={styles.contactsItem}>
                <View style={styles.contactsItemIcon}>
                  <item.icon width={24} height={24} color={styles.contactsItemIcon.color} />
                </View>
                <Text lineBreakMode='tail' style={styles.contactsItemValue}>
                  {item.value}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
      </View>
    </View>
  );
};
